import { Typography, Button, Stack } from '@mui/material';
import PageMeta from 'components/common/PageMeta';
import PageWithHeader from 'components/common/PageWithHeader';
import React from 'react';

import { useRouter } from '../../hooks/useRouter';

const NotFound: React.FC = () => {
  const router = useRouter();
  return (
    <PageWithHeader>
      <PageMeta
        title="Page not found"
        description="Sorry, we could not find the page you were looking for."
        noIndex
      />
      <Stack
        width="100%"
        spacing={10}
        data-cy="not-found-page"
        alignItems="center"
      >
        <div data-cy="not-found-message">
          <Typography variant="h1" align={'center'} data-cy="error-message">
            Sorry we could not find what you were looking for!
          </Typography>
        </div>
        <Button
          variant="contained"
          onClick={() => router.push(`/`)}
          data-cy="error-home-btn"
        >
          Go Home
        </Button>
      </Stack>
    </PageWithHeader>
  );
};

export default NotFound;
